// Microsoft Clarity (gravação de sessão/heatmap).
// DECISÃO DO DONO (16/10/2026): grava o SITE TODO — públicas, /paciente, /medico, /admin, /prontuario,
// /checkout — MENOS tudo que é "consulta" (sala/vídeo, sala de espera, chat e a aba Consultas do /admin).
// ⚠️ Antes era só páginas públicas, por LGPD: o Clarity grava a tela inteira (nome, telefone, CPF,
// dado de saúde) e envia à Microsoft. O dono foi avisado do risco e escolheu mesmo assim. Para reduzir
// o vazamento, no painel do Clarity (Settings → Masking) usar modo "Strict" (mascara todo texto/input).
// Para voltar ao modo restrito, reverter este arquivo (backup em /root/backups/manual-chat-paciente-20261016/).
const CLARITY_ID = "yypj4yz5dp";

type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[] };

/** Rotas de consulta: nunca gravar. `/consultar` (portal) NÃO é consulta — o regex exige o segmento exato. */
const CONSULTA_PATH = /(^|\/)(consultas?|sala-espera|chat)(\/|$)/;

export function clarityAllowedOnPath(pathname: string, _publicMode: boolean, search = ""): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (CONSULTA_PATH.test(p)) return false;
  // Aba "Consultas" do /admin (vive na URL: /admin?tab=consultas&view=...).
  if (p.startsWith("/admin") && new URLSearchParams(search).get("tab") === "consultas") return false;
  return true;
}

export function ensureClarity() {
  if (typeof window === "undefined") return;
  const w = window as unknown as { clarity?: ClarityFn };
  if (w.clarity) {
    try { w.clarity("start"); } catch { /* ignora */ }
    return;
  }
  const c: ClarityFn = function (...args: unknown[]) {
    (c.q = c.q || []).push(args);
  };
  w.clarity = c;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.clarity.ms/tag/${CLARITY_ID}`;
  document.head.appendChild(s);
}

/** Encerra a gravação ao entrar numa rota bloqueada (a SPA não recarrega a página). */
export function stopClarity() {
  if (typeof window === "undefined") return;
  const w = window as unknown as { clarity?: ClarityFn };
  if (!w.clarity) return;
  try { w.clarity("stop"); } catch { /* ignora */ }
}
